import * as React from "react";

export default function CartHeader() {
  return (
    <section className="flex flex-col justify-center items-center px-16 py-6 lg:h-[142px] md:h-[100.98px] h-[81px] sm:h-[81px]  w-full text-6xl font-bold tracking-wide text-center text-white bg-amber-600 max-md:px-5 max-md:max-w-full max-md:text-4xl">
      <div className="flex gap-6 justify-between items-center  max-md:text-4xl">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/d20a6fe424e248bb9a123f786a3857af/2a4b5d883bd4685c07b1a46d3c5bf6e050ece4eb80c9d2208f5da8442b88adde?apiKey=d20a6fe424e248bb9a123f786a3857af&"
          alt="Cart Icon"
          className="object-contain shrink-0 self-stretch my-auto aspect-square md:w-[35.52px] lg:w-[58px] w-[27.49px] sm:w-[27.49px]"
        />
        <h1 className=" lg:text-[60px] text-[28.44px] sm:text-[28.44px] md:text-[36.75px]">
          My Cart
        </h1>
      </div>
    </section>
  );
}
